'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');



/*****************
 ** WEBPACK FOOTER
 ** (webpack)/~/querystring-es3/index.js
 ** module id = 1345
 ** module chunks = 0
 **/